import Vue from "vue";
import VueRouter from "vue-router";
import Routes from "./config/Routes.js";

Vue.use(VueRouter);

export const routes = [
  ...Routes,
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/SIBI/login/index.vue"),
  },
  {
    // 错误页面
    path: "*",
    component: () => import("@/views/ErrorPage.vue"),
  },
];
const router = new VueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

//前置守卫(guard)
router.beforeEach((to, from, next) => {
  if (
    from.name === null &&
    to.path !== "/login" &&
    !sessionStorage.getItem("token")
  ) {
    return next("/login");
  }

  next();
});

export default router;
